import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import 'semantic-ui-css/semantic.min.css';


import { render } from 'react-dom'
const appRoot = document.getElementById('root')
  appRoot.setAttribute('notranslate', true)
  render(<App />, appRoot)

// Rejestracja service workera -> działa jako PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      // 1. Dodajemy nasłuchiwanie na moment aktywacji nowej wersji
      waitingServiceWorker.addEventListener("statechange", (event) => {
        if (event.target.state === "activated") {
          // 2. Gdy nowa wersja jest gotowa, odświeżamy stronę
          window.location.reload();
        }
      });

      // 3. Wysyłamy sygnał SKIP_WAITING do Service Workera
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
});

reportWebVitals();
